<template>
    <div>
        <div v-if="value === null"></div>
        <div v-else-if="Array.isArray(value) && value.length === 0">[]</div>
        <ul v-else-if="Array.isArray(value)" style="margin-left: 1.5rem">
            <li v-for="subValue in value" style="list-style-type: disc">
                <AuditLogValue :name="name" :value="subValue" />
            </li>
        </ul>
        <div v-else-if="typeof value === 'boolean'">{{ value ? 'true' : 'false' }}</div>
        <div v-else-if="typeof value === 'object'">
            <div v-for="key in Object.keys(value).filter((k) => k !== 'szSessionToken')" class="audit-next-row">
                <AuditLogField :name="key" />
                <AuditLogValue :name="key" :value="value[key]" />
            </div>
        </div>
        <AuditLogValue v-else-if="isJSON" :name="name" :value="JSON.parse(value)" />
        <div v-else>{{ value }}</div>
    </div>
</template>

<script>
    import AuditLogField from './AuditLogField';

    export default {
        name: 'AuditLogValue',
        components: { AuditLogField },
        props: {
            name: {
                type: String,
                required: true,
            },
            value: {
                type: [Array, Boolean, Number, Object, String],
                default: null,
            },
        },
        computed: {
            isJSON() {
                if (this.value && typeof this.value === 'string' && ['{', '['].includes(this.value.substring(0, 1))) {
                    try {
                        const value = JSON.parse(this.value);
                        return typeof value === 'object';
                    } catch (e) {
                        return false;
                    }
                }

                return false;
            },
        },
    };
</script>
